var initialState = {
  current: null
};
export default initialState;